/*
 * Copyright (C) 2018 Bruno López Trigo
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import NavBar from "../components/global/NavBar";
import { ExpandMore as ExpandMoreIcon } from "@material-ui/icons";
import {
  Typography,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  ListItemIcon
} from "@material-ui/core";
import galicia from "../components/images/galicia.png";
import usc from "../components/images/usc.png";
import campusVida from "../components/images/campusvida.png";
import ue from "../components/images/ue.png";
import xunta from "../components/images/xunta.png";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import ListItemText from "@material-ui/core/ListItemText";
import xacobeo from "../components/images/xacobeo-color-original.jpg";
import citius_horizontal from "../components/images/citius_horizontal.png";
import Link from "@material-ui/core/Link";

const styles = theme => ({
  padding: {
    paddingTop: 64,
    marginBottom:100,
  },
  expansionPanelDetails: {
    display: "block"
  },
  appBar: {
    top: "auto",
    bottom: 0,
    zIndex: -1,
    backgroundColor: "white"
  },
  leftLogos: {
    height: 36,
    marginTop: 20,
    marginBottom: 20
  },
  rightLogos: {
    height: 60,
    marginTop: 20,
    marginBottom: 20
  },
  toolbar: {
    alignItems: "center",
    justifyContent: "space-around"
  },
  footer:{
    boxShadow: "0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
    display:"inline-table",
    justifyContent:"space-evenly",
    position:"fixed",
    bottom:0,
    height:100,
    left:0,
    width:"100%",
    backgroundColor:"white",
  },
  centerFotter:{
    display:"flex",
    justifyContent:"space-evenly",
  },
});

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes } = this.props;

    return (
        <Fragment>
          <NavBar
              language={this.props.language}
              handleLanguageChange={this.props.handleLanguageChange}
          />
          <Grid container justify="center" className={classes.padding}>
            <Grid item xs={12}>
              <ExpansionPanel defaultExpanded>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h4"> {this.props.language.labels[this.props.language.id].titleAbout1}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                  <Typography variant="body1">
                    {this.props.language.labels[this.props.language.id].licenseMessage1}
                  </Typography>
                  <Typography variant="body1">
                    {this.props.language.labels[this.props.language.id].licenseMessage2}
                  </Typography>
                  <Typography variant="body1">
                    {this.props.language.labels[this.props.language.id].licenseMessage3}{" "}
                    <Link target="_blank" rel="noopener"  href="https://www.gnu.org/licenses/old-licenses/gpl-2.0.txt">
                      https://www.gnu.org/licenses/old-licenses/gpl-2.0.txt
                    </Link>
                  </Typography>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel defaultExpanded>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h4">{this.props.language.labels[this.props.language.id].titleAbout2}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                  <List>
                    <ListItem >
                      <ListItemIcon>
                        <FiberManualRecordIcon fontSize="small"/>
                      </ListItemIcon>
                      <ListItemText >
                        <Typography variant="body1">
                          {this.props.language.labels[this.props.language.id].creditsMessage1}{" "}
                          <Link target="_blank" rel="noopener" href="https://citius.usc.es/">CiTIUS </Link>
                          {this.props.language.labels[this.props.language.id].creditsMessage2}
                          Raúl Vilas Piñeiro
                          {this.props.language.labels[this.props.language.id].creditsMessage3}{" "}
                          <Link target="_blank" rel="noopener" href="https://citius.gal/team/jose-maria-alonso-moral">
                            Dr. Jose María Alonso Moral
                          </Link>{" "}
                          {this.props.language.labels[this.props.language.id].creditsMessage4}{" "}
                          <Link target="_blank" rel="noopener"  href="https://citius.gal/team/alberto-jose-bugarin-diz">
                            Prof. Dr. Alberto José Bugarín Diz
                          </Link>
                          .{" "}{this.props.language.labels[this.props.language.id].creditsMessage5}{" "}
                          <b>
                            <Link target="_blank" rel="noopener" href="https://citius.usc.es/investigacion/proxectos/listado/disenando-sistemas-inteligentes-explicables-interaccionan-personas-generan-expli">
                              eXplica-IA: Designing eXplainable AI Systems which
                              interact with people in Natural Language
                            </Link>{" "}
                          </b>
                          {this.props.language.labels[this.props.language.id].creditsMessage6}{" "}
                          <Link target="_blank" rel="noopener" href="https://citius.usc.es/v/jose-maria-alonso-moral">
                            Dr. Jose M. Alonso
                          </Link>{" "}
                          {this.props.language.labels[this.props.language.id].creditsMessage7}{" "}
                          <Link target="_blank" rel="noopener" href={"https://gitlab.citius.usc.es/jose.alonso/xai"}>
                            XAI-GitLab
                          </Link>
                          .
                        </Typography>
                      </ListItemText>
                    </ListItem>
                    <ListItem >
                      <ListItemIcon>
                        <FiberManualRecordIcon fontSize="small"/>
                      </ListItemIcon>
                      <ListItemText >
                        <Typography variant="body1">
                          {this.props.language.labels[this.props.language.id].creditsMessage8}
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </List>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel defaultExpanded>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h4">{this.props.language.labels[this.props.language.id].titleAbout3}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                  <List>
                    <ListItem >
                      <ListItemIcon>
                        <FiberManualRecordIcon fontSize="small"/>
                      </ListItemIcon>
                      <ListItemText >
                        Jose M. Alonso, P. Ducange, R. Pecori, R. Vilas, <Link target="_blank" rel="noopener" href={"http://doi.org/10.1109/FUZZ48607.2020.9177725"}> "Building Explanations for Fuzzy Decision Trees with the ExpliClas Software"</Link>, IEEE World Congress on Computational Intelligence, Glasgow (Scotland), 2020.
                      </ListItemText>
                    </ListItem>
                    <ListItem >
                      <ListItemIcon>
                        <FiberManualRecordIcon fontSize="small"/>
                      </ListItemIcon>
                      <ListItemText >
                        <Typography variant="body1">
                          Jose M. Alonso, A. Bugarin,{" "}
                          <Link target="_blank" rel="noopener" href={"http://dx.doi.org/10.1109%2FFUZZ-IEEE.2019.8859018"}>
                            "ExpliClas: Automatic Generation of Explanations in Natural Language for Weka Classifiers"
                          </Link>
                          , IEEE International Conference on Fuzzy Systems, New Orleans, Louisiana (USA), 2019.
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </List>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h4">{this.props.language.labels[this.props.language.id].titleAbout4}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                  <Typography variant="body1">
                    {this.props.language.labels[this.props.language.id].iconsMessage1}{" "}
                    <Link target="_blank" rel="noopener" href="https://material.io/tools/icons/?style=baseline">
                      Material Design Icons
                    </Link>
                    . {this.props.language.labels[this.props.language.id].iconsMessage2}{" "}
                    <Link target="_blank" rel="noopener" href="https://www.apache.org/licenses/LICENSE-2.0.html">
                      https://www.apache.org/licenses/LICENSE-2.0.html
                    </Link>
                  </Typography>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h4">{this.props.language.labels[this.props.language.id].titleAbout5}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                  <Typography variant="body1">
                    {this.props.language.labels[this.props.language.id].imagesMessage1}{" "}
                    <Link target="_blank" rel="noopener" href="https://pixabay.com/">Pixabay</Link>.
                  </Typography>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </Grid>
          </Grid>
          <footer className={classes.footer}>
            <Grid container direction="row" alignItems="center" justify={"center"}>
              <Grid  className={classes.centerFotter} item xs={12} md={8} lg={8} >
                <img
                    src={galicia}
                    alt="logo turístico galicia"
                    className={classes.leftLogos}
                />
                <img
                    src={xacobeo}
                    alt="logo xacobeo 2021"
                    className={classes.leftLogos}
                />
                <img src={citius_horizontal} alt="logo citius" className={classes.leftLogos} />
                <img src={usc} alt="logo usc" className={classes.leftLogos} />
                <img
                    src={campusVida}
                    alt="logo campus vida"
                    className={classes.leftLogos}
                />
              </Grid>
              <Grid className={classes.centerFotter}  item xs={12} md={4} lg={4} >
                <img
                    src={ue}
                    alt="logo unión europea"
                    className={classes.rightLogos}
                />
                <img
                    src={xunta}
                    alt="logo xunta de galicia"
                    className={classes.rightLogos}
                />
              </Grid>
            </Grid>
            <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "center"}}>
              {this.props.language.labels[this.props.language.id].fondoEuropeo}
            </Typography>
          </footer>
        </Fragment>
    );
  }
}

About.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(About);
